// extracted by mini-css-extract-plugin
export default {"card":"ServiceCard_card__u7KjQ","image":"ServiceCard_image__i-2Td","icon":"ServiceCard_icon__5zfEc","title":"ServiceCard_title__1saKF"};